import { useState } from "react";
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import PolybotAIAgent from "@/pages/PolybotAIAgent";

export default function FloatingAIAgent() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="fixed bottom-6 right-6 z-50">
        <Button
          aria-label="Open AI Agent"
          size="icon"
          className="h-14 w-14 rounded-full shadow-xl"
          onClick={() => setOpen(true)}
        >
          <Sparkles className="h-6 w-6" />
        </Button>
      </div>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent
          side="right"
          hideOverlay
          className="h-[90vh] my-5 mr-5 p-0 w-[95vw] sm:w-[85vw] md:w-[70vw] lg:w-[45vw] xl:w-[40vw] rounded-2xl border shadow-2xl overflow-hidden"
        >
          <div className="h-full overflow-hidden bg-background">
            <PolybotAIAgent />
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}


